import { supabase } from '@/lib/supabase';

export type ServicePriceUnit = 'fixed' | 'hourly' | 'per_item' | 'per_meter' | 'per_sqm';

export type ProfessionalService = {
  id: string;
  profile_id: string;
  title: string;
  description: string | null;
  price: number | null;
  price_unit: ServicePriceUnit;
  is_active: boolean;
  sort_order: number;
  created_at: string;
};

const COLS = 'id, profile_id, title, description, price, price_unit, is_active, sort_order, created_at';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = supabase as any;

/** Όλες οι υπηρεσίες του τρέχοντος χρήστη (ενεργές + ανενεργές), για διαχείριση στο προφίλ. */
export async function fetchMyServices(userId: string): Promise<ProfessionalService[]> {
  const { data, error } = await db
    .from('professional_services')
    .select(COLS)
    .eq('profile_id', userId)
    .order('sort_order', { ascending: true })
    .order('created_at', { ascending: true });
  if (error) throw error;
  return (data ?? []) as ProfessionalService[];
}

/** Ενεργές υπηρεσίες ενός επαγγελματία, για δημόσια προβολή στο portfolio. */
export async function fetchServicesForProfile(profileId: string): Promise<ProfessionalService[]> {
  const { data, error } = await db
    .from('professional_services')
    .select(COLS)
    .eq('profile_id', profileId)
    .eq('is_active', true)
    .order('sort_order', { ascending: true })
    .order('created_at', { ascending: true });
  if (error) throw error;
  return (data ?? []) as ProfessionalService[];
}

export async function createService(
  userId: string,
  input: { title: string; description?: string | null; price?: number | null; priceUnit?: ServicePriceUnit },
): Promise<ProfessionalService> {
  const { data, error } = await db
    .from('professional_services')
    .insert({
      profile_id: userId,
      title: input.title.trim(),
      description: input.description?.trim() || null,
      price: input.price ?? null,
      price_unit: input.priceUnit ?? 'fixed',
    })
    .select(COLS)
    .single();
  if (error) throw error;
  return data as ProfessionalService;
}

export async function updateService(
  id: string,
  patch: Partial<{ title: string; description: string | null; price: number | null; price_unit: ServicePriceUnit; is_active: boolean }>,
): Promise<void> {
  const { error } = await db.from('professional_services').update(patch).eq('id', id);
  if (error) throw error;
}

export async function deleteService(id: string): Promise<void> {
  const { error } = await db.from('professional_services').delete().eq('id', id);
  if (error) throw error;
}
